/**
 * ****************************************************************************
 * @description     :   Factory to create or call api to get data for all app
 * @created at      :   2022/07/13
 * @created by      :   
 * @package         :   dailyreportsystem
 * @copyright       :   Copyright (c)
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Factory to create or call api to get data for all app
 * -----------------------------------------
 * @author : create
 * @access : public
 */
const Factory = {
    /**
     * Create data for menus on left-menu
     * -----------------------------------------
     * @author : create
     * @returns: {Array} - List data of menu on left-menu
     * @access : public
     */
    GetMenus: () => {
        let menus = [];
        try {
            menus = [
                {
                    id: 1,
                    type: "menu",
                    title: "日報",
                    icon: "icon ni ni-calendar",
                    to: "/daily-report-system",
                    header: {
                        showLeftHeader: true,
                        dataTitle: {
                            icon: "icon ni ni-calendar bg-info-dim",
                            subText: "日報",
                            leadText: "NioChats",
                        },
                    },
                },
            ];
        } catch (e) {
            console.log(`GetMenus: ${e.message}`);
        }
        return menus;
    },
    /**
     * Get menu of current page follow url of page
     * -----------------------------------------
     * @author : create
     * @param  : {Array} menus - List menus on left -menu
     * @param  : {string} url - Url of curent pages 
     * @returns: {Object} - Information of curent page
     * @access : public
     */
    GetMenu: (menus, url) => {
        let result = {};
        try {
            // Set default information
            result = {
                currentMenu: "/daily-report-system",
                showLeftHeader: true,
                dataTitle: {
                    icon: "ni-dashlite bg-purple-dim",
                    subText: "DashLite",
                    leadText: "Dashboard",
                },
            };
            let title = "Analytics Dashboard";
            // Set information for page error
            if (url !== "/") {
                title = "Error 404";
                result.currentMenu = "/404";
            }
            // Search data menu follow url
            menus.forEach(function (menu) {
                if (menu.to && menu.to === url) {
                    result.currentMenu = url;
                    result.showLeftHeader = menu.header.showLeftHeader;
                    result.dataTitle = menu.header.dataTitle;
                    title = menu.title;
                }
            });
            // Change title
            document.title = `${title} | DashLite Admin Template`;
        } catch (e) {
            console.log(`GetMenu: ${e.message}`);
        }
        return result;
    },
    /**
     * Create data for chats dropdown on right-header
     * -----------------------------------------
     * @author : create
     * @returns: {Array} - List data of messages on right-header
     * @access : public
     */
    GetChats: () => {
        let messages = [];
        try {
            messages = [
                {
                    id: 1,
                    title: "",
                    content: "",
                    time: "Now",
                    status: 1, // delivered
                    onlineStatus: 0, // Online
                    isGroup: false,
                    color: "bg-purple",
                    letter: "IH",
                }
            ];
        } catch (e) {
            console.log(`GetChats: ${e.message}`);
        }
        return messages;
    },
    /**
     * Create data for notify dropdown on right-header
     * -----------------------------------------
     * @author : create
     * @returns: {Array} - List data of messages on right-header
     * @access : public
     */
    GetNotify: () => {
        let notify = [];
        try {
            notify = [
                {
                    id: 1,
                    title: "",
                    time: "Just now",
                    icon: "ni-share",
                    color: "bg-primary-dim"
                }
            ];
        } catch (e) {
            console.log(`GetNotify: ${e.message}`);
        }
        return notify;
    },
    /**
     * Create data for sidebar menu on mobile
     * -----------------------------------------
     * @author : create
     * @returns: {Array} - List data of menus on sidebar
     * @access : public
     */
    GetSidebar: () => {
        let menus = [];
        try {
            menus = [
                {
                    id: 1,
                    type: "menu",
                    title: "日報",
                    icon: "icon ni ni-calendar",
                    href: "/daily-report-system"
                }
            ];
        } catch (e) {
            console.log(`GetSidebar: ${e.message}`);
        }
        return menus;
    }
};

export default Factory;
